import React from "react";
import { OurNodeDetailsPanel } from "../node-details-panel/our-node-details-panel";
import { useTreeStructureHook } from "./use-tree-structure-hook";
import { FluidToFixSplitContainer } from "@src/components/templates/layouts/fluid-to-fix-split-container/fluid-to-fix-split-container";
import { HalfSplitContainer } from "@src/components/templates/layouts/half-split-container/half-split-container";
import { InitialStructurePanel } from "../initial-structure-panel/initial-structure-panel";
import { MachineStructurePanel } from "../machine-structure-panel/machine-structure-panel";

export const TreeStructure = () => {
  const returnNodeDetailsPanel = () => {
    return <OurNodeDetailsPanel />;
  };

  const { showNodeDetailsPanel } = useTreeStructureHook();

  return (
    <>
      <FluidToFixSplitContainer>
        <HalfSplitContainer isDraggable={true} flexGrow={true}>
          <InitialStructurePanel />
          <MachineStructurePanel />
        </HalfSplitContainer>
        {showNodeDetailsPanel && returnNodeDetailsPanel()}
      </FluidToFixSplitContainer>
    </>
  );
};
